import { render, staticRenderFns } from "./auth-settings.vue?vue&type=template&id=a4827624&lang=pug&"
import script from "./auth-settings.vue?vue&type=script&lang=js&"
export * from "./auth-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports